<template>
<div class="container">
    <div class="row d-flex">
        <div class="col-12 col-xl-10">
            <div class="content-fixed">
                <Button @click="$router.go(-1)" size="small" type="outline" color="grey" class="mb-3">
                    <ArrowDropdown :rotate="90" /> Voltar
                </Button>
                <div class="d-flex align-items-center justify-content-between">
                    <div>
                        <h3 class="regular c-ndarkthree">
                            <span class="c-ndarkthree bold">Detalhes do Fornecedor</span>
                            <span class="c-nmidfour"> | </span>
                            {{ provider.tradingName | formatName }}
                        </h3>
                    </div>
                    <div>
                        <Button size="medium" :color="getPrimaryColor" @click="downloadAll(provider.id)" v-if="filesAdministrators.length > 0 || provider.cnpj.document.length > 0">
                            <Download color="#fff" /> Baixar todos os documentos
                        </Button>
                    </div>
                </div>
            </div>
            <!-- <div class="d-flex justify-content-end align-items-center pr-0">
                <Button size="small" color="blue" @click="downloadAll(info.id)">
                    <Download color="#fff" /> Baixar tudo
                </Button>
            </div> -->
        </div>
        <div class="col-12 mt-4 box-details">
            <h4 class="medium ndarkfour mb-3">Sobre o cedente</h4>
            <AboutProfileProvider class="col-12 col-xl-10" :provider="provider" :companyInfo="companyInfo" />
        </div>
        <div class="col-12 mt-4 box-details pt-2 account-bank">
            <h4 class="medium ndarkfour mb-3">Conta bancária
                <el-tooltip class="item" content="O pagamento ao cedente deve ser realizado na conta indicada na plataforma." placement="bottom">
                    <AlertExclamation :size="20" color="#E19700" />
                </el-tooltip>
            </h4>
            <div class="col-12 col-xl-10 pd-skeleton" v-if="providerIsEmpty">
                <el-skeleton style="width: 100%; height: 115px;" animated>
                    <template slot="template">
                        <el-skeleton-item variant="rect" style="width: 100%; height: 115px;" />
                    </template>
                </el-skeleton>
            </div>
            <AccountBank class="col-12 col-xl-10" :info="mainBankAccount" :name="provider.name" v-else/>
        </div>
        <div class="col-12 mt-4 box-details pt-2">
            <h4 class="medium ndarkfour mb-3">Contato</h4>
            <div class="col-12 col-xl-10 pd-skeleton" v-if="providerIsEmpty">
                <el-skeleton style="width: 100%; height: 115px;" animated>
                    <template slot="template">
                        <el-skeleton-item variant="rect" style="width: 100%; height: 115px;" />
                    </template>
                </el-skeleton>
            </div>
            <Contact class="col-12 col-xl-10" :info="provider" v-else/>
        </div>
        <div class="col-12 mt-4 box-details pt-2" v-if="provider.administrators.length">
            <h4 class="medium ndarkfour mb-3">Sócios</h4>
            <div class="col-12 col-xl-10 pd-skeleton" v-if="providerIsEmpty">
                <el-skeleton style="width: 100%; height: 115px;" animated>
                    <template slot="template">
                        <el-skeleton-item variant="rect" style="width: 100%; height: 115px;" />
                    </template>
                </el-skeleton>
            </div>
            <ProviderPartners class="" :administrators="provider.administrators" v-else/>
        </div>
        <div class="col-12 mt-4 box-details pt-2">
            <h4 class="medium ndarkfour mb-3">Sacados vinculados</h4>
            <div class="col-12 col-xl-10 pd-skeleton" v-if="providerIsEmpty">
                <el-skeleton style="width: 100%; height: 115px;" animated>
                    <template slot="template">
                        <el-skeleton-item variant="rect" style="width: 100%; height: 115px;" />
                    </template>
                </el-skeleton>
            </div>
            <div v-else>
                <TableLoading v-if="loading" :rows="3" class="mt-3"/>
                <div class="col-12 col-xl-10 p-0" v-else>
                    <ProviderEconomicGroupsLinked  :economicGroups="providerGroups"/>
                    <PaginationButtons
                        :pagination="pagination"
                        @next="paginationNextAndPrev($event)"
                        @prev="paginationNextAndPrev($event)"
                        :totaPerPage="20"
                    />
                </div>
            </div>
        </div>
        <div class="col-12 mt-4 box-details pt-2" v-if="provider.headquarters">
            <h4 class="medium ndarkfour mb-3">Local</h4>
            <div class="col-12 col-xl-10 pd-skeleton" v-if="providerIsEmpty">
                <el-skeleton style="width: 100%; height: 115px;" animated>
                    <template slot="template">
                        <el-skeleton-item variant="rect" style="width: 100%; height: 115px;" />
                    </template>
                </el-skeleton>
            </div>
            <Adress class="col-12 col-xl-10" :info="provider.headquarters" v-else />
        </div>
        <div class="col-12 mt-4 box-details pt-2 px-0">
            <ListDocumentsVue class="col-12 col-xl-10" :info="provider" />
        </div>
        <div class="spacer" style="margin-bottom:150px;" />
    </div>
    <FullLoading :color="getPrimaryColorHex.five" v-show="$store.state.user.loading" />
</div>
</template>

<script>

// APIs
import getProviders from '@/api/getProviders'
import getCompanyInfos from '@/api/getCompanyInfos'
import downloadAllFilesProvider from '@/api/downloadAllFilesProvider'
import downloadArchive from '@/api/downloadArchive'
import getAllGroupsByProviderId from '@/api/getAllGroupsByProviderId'

// Icons
import ArrowDropdown from '@/components/icons/ArrowDropdown'
import AlertExclamation from '@/components/icons/AlertExclamation.vue'
import Download from '@/components/icons/Download.vue'

// Abouts
import AboutProfileProvider from '@/components/about/AboutProfileProvider.vue'
import AccountBank from '@/components/about/AccountBank.vue'
import Contact from '@/components/about/Contact.vue'
import Adress from '@/components/about/Adress.vue'
import ListDocumentsVue from '@/components/about/ListDocuments.vue'
import ProviderPartners from '@/components/about/ProviderPartners.vue'

// Utils
import banksList from '@/utils/banksList'

// Misc
import FullLoading from '@/components/loading/FullLoading'
import TableLoading from '@/components/loading/TableLoading'
import ProviderEconomicGroupsLinked from '@/components/tables/ProviderEconomicGroupsLinked'
import PaginationButtons from '@/components/pagination/PaginationButtons'

export default {
    components: {
        ArrowDropdown,
        AboutProfileProvider,
        AccountBank,
        AlertExclamation,
        Contact,
        Adress,
        ListDocumentsVue,
        FullLoading,
        Download,
        ProviderEconomicGroupsLinked,
        PaginationButtons,
        TableLoading,
        ProviderPartners,
    },
    methods: {
        getBankAccount() {
            let mainBank = this.provider.banks.find(bankInfo => bankInfo.bank == '274')
            if (!mainBank || !this.$store.state.user.availableToFomentation) {
                mainBank = this.provider.banks.find(bankInfo => bankInfo.mainAccount == 1)
            }
            if (mainBank) {
                const bankName = banksList.find(bank => bank.COMPE == mainBank.bank)
                this.mainBankAccount = {
                    ...mainBank,
                    bank: `${mainBank.bank} - ${bankName.ShortName}`,
                }
            }
        },
        async downloadAll(id) { 
            this.$store.commit('user/setIsDownloadLoading', true)
            const result = await downloadAllFilesProvider(id)
            await downloadArchive(`${process.env.VUE_APP_ROOT_API}/${result}`)

            this.$store.commit('user/setIsDownloadLoading', false)
        },
        async getProvidersGroup() {
            this.loading = true

            const partner = this.USER_TYPE_MIXIN.isAdm ? null : this.getWhiteLabel

            const resp = await getAllGroupsByProviderId(this.provider.id, { 
                withBuyers: true, 
                registerActive: true, 
                page: this.page,
                partner
            })

            this.providerGroups = resp.rows
            this.pagination = resp.pagination
            
            this.loading = false
        },
        async paginationNextAndPrev(page) {
            this.page = page
            await this.getProvidersGroup()
        },
    },
    data() {
        return {
            provider: {},
            companyInfo: {},
            mainBankAccount: {},
            providerGroups: [],
            page: 1,
            pagination: {},
            loading: false,
        }
    },
    computed: {
        filesAdministrators: function () {
            const files = []
            this.provider.administrators ?  this.provider.administrators.map((administrator) => {
                administrator.document.map((documents) => {
                    files.push({
                        path: documents.path,
                        originalFileName: documents.originalFileName
                    })
                })
            }) : []
            return files
        },
        providerIsEmpty() {
            return Object.keys(this.provider).length == 0
        }
    },
    async created() {
        this.provider = await getProviders(this.$route.params.id)
        this.companyInfo = await getCompanyInfos(null, this.provider.id) 
        this.getBankAccount()
        await this.getProvidersGroup()
    },
}
</script>

<style>
.pd-skeleton {
    padding-left: 0px;
    padding-right: 0px;
}
</style>
